import firebase from "firebase/compat/app";
import "./firebaseConfig";

export default {
  api_keys: {
    uploadcare: "b84367cf8636092ee2f9",
    googlemaps: "AIzaSyCVKdmjbNJTC6UxDdrDFtG9cft_Pd7oNvM"
  },
  errors: {
    "auth/invalid-email": "Entered email is invalid",
    "auth/user-disabled": "This user account has been disabled",
    "auth/user-not-found": "We couldn't find an account with this email",
    "auth/wrong-password": "Invalid email/password combination",
    "auth/email-already-in-use": "This email is already in use, please log in",
    "auth/operation-not-allowed":
      "Sorry, you cannot create an account at this time",
    "auth/weak-password": "Your password must be at least 6 characters",
    fill_fields: "Please fill in all the fields",
    password_match: "Your passwords do not match, please re-enter them",
    email: "Error in sending email",
    settings_error: "There was an error in updating your profile",
    payment: "An error ocurred and we could not process your payment",
    card_error: "An error ocurred in saving your card (invalid card)",
    card_delete_error: "An error ocurred in deleting your card",
    subscription_error: "An error ocurred in creating your subcription",
    subscription_cancel_error:
      "An error ocurred in cancelling your subcription",
    subscription_reactivation_error:
      "An error ocurred in reactivating your subcription",
    privilege_error: "An error ocurred in changing the user privileges",
    download_pdf_error: "An error ocurred in downloading your invoice",
    fetch_by_email_error: "We couldn't find a user with this email",
    add_user_error: "An error ocurred in adding this user to your subscription",
    remove_user_error:
      "An error ocurred in removing this user from your subscription"
  },
  info: {
    verify_email:
      "Please verify your email by clicking on the link in your inbox",
    logged_out: "You have been successfully logged out",
    sending_reset: "Sending reset link...",
    sent_reset: "Your password reset link has been sent",
    profile_updated: "Your profile has been updated",
    billing_info_updated: "Your billing details have been updated",
    payment: "Please wait while we verify your payment details...",
    thanks:
      "Thank you for your order! Someone from our team will be in touch shortly.",
    sent: "Sent!",
    card_delete_confirm: "Are you sure you want to delete your card?",
    subscription_cancel_confirm:
      "Are you sure you want to cancel your subscription?",
    card_added: "Your card has been added",
    card_updated: "Your card has been updated",
    card_deleted: "Your card has been deleted",
    subscription_created: "Subscription created successfully",
    subscription_deleted: "Subscription cancelled successfully",
    subscription_updated: "Subscription updated successfully",
    subscription_reactivated: "Subscription reactivated successfully",
    user_added: "User added successfully",
    access_revoked: "Access has been revoked from user",
    role_edited: "User role changed successfully"
  },
  actions: {
    send_reset: "Send reset link"
  },
  profile: {
    default_user_image:
      "https://ucarecdn.com/1cc06c4c-cb90-4ce2-a8ce-520291e651d5/defaultprofile.png"
  },
  urls: {
    apiContact: "https://usebasin.com/f/c0fe176644b1.json",
    functionsBase: `https://us-central1-${
      firebase.app().options.projectId
    }.cloudfunctions.net/api/`,
    gMapsStaticBase: "https://maps.googleapis.com/maps/api/staticmap",
    gMapsDimenctionBase:
      "https://maps.googleapis.com/maps/api/distancematrix/json",
    blueMarker: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
    greenMarker: "https://maps.google.com/mapfiles/ms/icons/green-dot.png"
  },
  monthNames: [
    "Jan",
    "Feb",
    "Mar",
    "April",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  fileExts: {
    ".bplx": ".bplx",
    ".kml": ".kml",
    ".kmz": ".kmz"
  },
  markerFilters: {
    plan: {
      _id: "plan",
      imageUrl: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
      label: "Plan"
    },
    asbuilt: {
      _id: "asbuilt",
      imageUrl: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
      label: "As-built"
    }
  },
  dataNames: {
    subscriptions: {
      subscriptions: "subscription",
      user: {
        id: "id",
        role: "role"
      },
      type: {
        type: "type",
        free: "free",
        paid: "paid"
      },
      cancelled: "cancelled"
    },
    users: {
      users: "users",
      card: "card"
    },
    userRoles: {
      uid: "uid",
      sid: "sid",
      role: "role",
      roles: {
        admin: "admin",
        manager: "manager",
        member: "member"
      },
      userRoles: "userRoles"
    },
    geoFences: {
      geoFences: "geoFences",
      sid: "sid",
      name: "name",
      addedBy: "addedBy",
      createdOn: "createdOn",
      polygon: "polygon"
    },
    jobs: {
      jobs: "jobs",
      name: "name",
      sid: "sid",

      isImported: "isImported",
      importStatus: "importStatus",
      originalFileUrl: "originalFileUrl",
      importFileExt: "importFileExt",
      uploadedAt: "uploadedAt",
      importCompletedAt: "importCompletedAt",
      importFiledownloadUrl: "importFiledownloadUrl",

      // collections
      waypointList: "waypointList",
      pointContainerList: "pointContainerList",

      importStatuses: {
        uploaded: "Uploaded",
        imported: "Imported"
      }
    },
    template: {
      collection: "templates",
      doc: {
        templateName: "templateName",
        color: "color",
        icon: "icon",
        polyline: "polyline",
        detailsDialog: "detailsDialog",
        clearenceArea: "clearenceArea",
        fields: {
          name: "name",
          type: "type",
          fieldUnitType: "fieldUnitType"
        }
      },
      header: [
        "#",
        "Assets Name",
        "Polyline color",
        "Icon",
        "Polyline",
        "Details Dialog",
        "Clearance Area",
        "Fields"
      ]
    },
    invoice: {
      header: ["#", "Invoice No", "Period", "Status", "Amount"]
    },
    icons: {
      collection: "icons",
      doc: {
        title: "title",
        url: "url"
      }
    },
    waypointList: {
      position: {
        position: "position",
        coords: {
          coords: "coords"
        }
      }
    }
  },
  country: [
    {
      label: "+91",
      value: "+91"
    },
    {
      label: "+1",
      value: "+1"
    }
  ]
};

export const copyToClipboard = text => {
  // create dummy text area.
  const textarea = document.createElement("textarea");
  document.body.appendChild(textarea);

  textarea.value = text;
  // select text from text area
  textarea.setSelectionRange(0, 99999);
  textarea.select();

  document.execCommand("copy");

  // remove dummy textarea now.
  return document.body.removeChild(textarea);
};

export const utilityIcons = [
  {
    title: "Access point",
    dial_code: "Access point",
    code: "access_point"
  },
  {
    title: "Assembly",
    dial_code: "Assembly",
    code: "Assembly"
  },
  {
    title: "Centralized BMP",
    dial_code: "Centralized BMP",
    code: "Centralized_BMP"
  },
  {
    title: "Cleanout - Water device",
    dial_code: "Cleanout - Water device",
    code: "Cleanout_Water_device"
  },
  {
    title: "Cleanout",
    dial_code: "Cleanout",
    code: "Cleanout"
  },
  {
    title: "Controllable valve",
    dial_code: "Controllable valve",
    code: "Controllable_valve"
  },
  {
    title: "Controller",
    dial_code: "Controller",
    code: "Controller"
  },
  {
    title: "De-centralized BMP",
    dial_code: "De-centralized BMP",
    code: "De_centralized_BMP"
  },
  {
    title: "Discharge",
    dial_code: "Discharge",
    code: "Discharge"
  },
  {
    title: "Filter",
    dial_code: "Filter",
    code: "Filter"
  },
  {
    title: "Fire hydrant",
    dial_code: "Fire hydrant",
    code: "Fire_hydrant"
  },
  {
    title: "Fiting reducing cross",
    dial_code: "Fiting reducing cross",
    code: "Fiting_reducing_cross"
  },
  {
    title: "Fitting bend",
    dial_code: "Fitting bend",
    code: "Fitting_bend"
  },
  {
    title: "Fitting cap",
    dial_code: "Fitting cap",
    code: "Fitting_cap"
  },
  {
    title: "Fitting coupling",
    dial_code: "Fitting coupling",
    code: "Fitting_coupling"
  },
  {
    title: "Fitting cross",
    dial_code: "Fitting cross",
    code: "Fitting_cross"
  },
  {
    title: "Fitting expansion",
    dial_code: "Fitting expansion",
    code: "Fitting_expansion"
  },
  {
    title: "Fitting over under",
    dial_code: "Fitting over under",
    code: "Fitting_over_under"
  },
  {
    title: "Fitting reducer",
    dial_code: "Fitting reducer",
    code: "Fitting_reducer"
  },
  {
    title: "Fitting reducing tee",
    dial_code: "Fitting reducing tee",
    code: "Fitting_reducing_tee"
  },
  {
    title: "Fitting sleeve",
    dial_code: "Fitting sleeve",
    code: "Fitting_sleeve"
  },
  {
    title: "Fitting tee",
    dial_code: "Fitting tee",
    code: "Fitting_tee"
  },
  {
    title: "Fitting transition",
    dial_code: "Fitting transition",
    code: "Fitting_transition"
  },
  {
    title: "Flow valve",
    dial_code: "Flow valve",
    code: "Flow_valve"
  },
  {
    title: "Flushing blow off",
    dial_code: "Flushing blow off",
    code: "Flushing_blow_off"
  },
  {
    title: "Gas pipeline assembly",
    dial_code: "Gas pipeline assembly",
    code: "Gas_pipeline_assembly"
  },
  {
    title: "Injection facility",
    dial_code: "Injection facility",
    code: "Injection_facility"
  },
  {
    title: "Inlet device",
    dial_code: "Inlet device",
    code: "Inlet_device"
  },
  {
    title: "Inline storage",
    dial_code: "Inline storage",
    code: "Inline_storage"
  },
  {
    title: "Ladder",
    dial_code: "Ladder",
    code: "Ladder"
  },
  {
    title: "Meter",
    dial_code: "Meter",
    code: "Meter"
  },
  {
    title: "Monitoring",
    dial_code: "Monitoring",
    code: "Monitoring"
  },
  {
    title: "Outlet",
    dial_code: "Outlet",
    code: "Outlet"
  },
  {
    title: "Pipe connection",
    dial_code: "Pipe connection",
    code: "Pipe_connection"
  },
  {
    title: "Pressure valve",
    dial_code: "Pressure valve",
    code: "Pressure_valve"
  },
  {
    title: "Pump",
    dial_code: "Pump",
    code: "Pump"
  },
  {
    title: "Service connection",
    dial_code: "Service connection",
    code: "Service_connection"
  },
  {
    title: "Sewer assembly",
    dial_code: "Sewer assembly",
    code: "Sewer_assembly"
  },
  {
    title: "Sewer gate",
    dial_code: "Sewer gate",
    code: "Sewer_gate"
  },
  {
    title: "Sewer strorm vault",
    dial_code: "Sewer strorm vault",
    code: "Sewer_strorm_vault"
  },
  {
    title: "Station",
    dial_code: "Station",
    code: "Station"
  },
  {
    title: "Storage - water device",
    dial_code: "Storage - water device",
    code: "Storage_water_device"
  },
  {
    title: "Storage",
    dial_code: "Storage",
    code: "Storage"
  },
  {
    title: "Stormwater junction",
    dial_code: "Stormwater junction",
    code: "Stormwater_junction"
  },
  {
    title: "Stormwater",
    dial_code: "Stormwater",
    code: "Stormwater"
  },
  {
    title: "Structure junction",
    dial_code: "Structure junction",
    code: "Structure_junction"
  },
  {
    title: "Supply",
    dial_code: "Supply",
    code: "Supply"
  },
  {
    title: "Wall",
    dial_code: "Wall",
    code: "Wall"
  },
  {
    title: "Water access point",
    dial_code: "Water access point",
    code: "Water_access_point"
  },
  {
    title: "Weir",
    dial_code: "Weir",
    code: "Weir"
  },
  {
    title: "Automatic Flushing",
    dial_code: "Automatic Flushing",
    code: "Automatic_flushing"
  },
  {
    title: "Bio Filtration",
    dial_code: "Bio Filtration",
    code: "Bio_filtration"
  },
  {
    title: "Bio Retention",
    dial_code: "Bio Retention",
    code: "Bio_retention"
  },
  {
    title: "Bioswale",
    dial_code: "Bioswale",
    code: "Bioswale"
  },
  {
    title: "Blow off",
    dial_code: "Blow off",
    code: "Blow_off"
  },
  {
    title: "Broad Crested",
    dial_code: "Broad Crested",
    code: "Broad_crested"
  },
  {
    title: "Bypass Outlet",
    dial_code: "Bypass Outlet",
    code: "Bypass_outlet"
  },
  {
    title: "Catchment Discharge",
    dial_code: "Catchment Discharge",
    code: "Catchment_discharge"
  },
  {
    title: "Chlorination",
    dial_code: "Chlorination",
    code: "Chlorination"
  },
  {
    title: "Connection Controll",
    dial_code: "Connection Controll",
    code: "Connection_controll"
  },
  {
    title: "Detention Basin",
    dial_code: "Detention Basin",
    code: "Detention_basin"
  },
  {
    title: "Dry Basin",
    dial_code: "Dry Basin",
    code: "Dry_basin"
  },
  {
    title: "Filtration Device",
    dial_code: "Filtration Device",
    code: "Filtration_device"
  },
  {
    title: "Fire Plug Valve",
    dial_code: "Fire Plug Valve",
    code: "Fire_plug_valve"
  },
  {
    title: "Fluoridation",
    dial_code: "Fluoridation",
    code: "Fluoridation"
  },
  {
    title: "Hand Hole",
    dial_code: "Hand Hole",
    code: "Hand_hole"
  },
  {
    title: "Infiltratio Feature",
    dial_code: "Infiltratio Feature",
    code: "Infiltratio_feature"
  },
  {
    title: "Infiltration Basin",
    dial_code: "Infiltration Basin",
    code: "Infiltration_basin"
  },
  {
    title: "Labyrinth",
    dial_code: "Labyrinth",
    code: "Labyrinth"
  },
  {
    title: "Lamp Hole Cover",
    dial_code: "Lamp Hole Cover",
    code: "Lamp_hole_cover"
  },
  {
    title: "Manhole Cover",
    dial_code: "Manhole Cover",
    code: "Manhole_cover"
  },
  {
    title: "Media Filter",
    dial_code: "Media Filter",
    code: "Media_filter"
  },
  {
    title: "Minimum Energy Loss",
    dial_code: "Minimum Energy Loss",
    code: "Minimum_energy_loss"
  },
  {
    title: "Pervious Pavement",
    dial_code: "Pervious Pavement",
    code: "Pervious_pavement"
  },
  {
    title: "Pipe Connection",
    dial_code: "Pipe Connection",
    code: "Pipe_connection"
  },
  {
    title: "Pipe End",
    dial_code: "Pipe End",
    code: "Pipe_end"
  },
  {
    title: "Post Hydrant",
    dial_code: "Post Hydrant",
    code: "Post_hydrant"
  },
  {
    title: "Reservoir",
    dial_code: "Reservoir",
    code: "Reservoir"
  },
  {
    title: "Residential",
    dial_code: "Residential",
    code: "Residential"
  },
  {
    title: "Sediment Trap",
    dial_code: "Sediment Trap",
    code: "Sediment_trap"
  },
  {
    title: "Setting Basin",
    dial_code: "Setting Basin",
    code: "Setting_basin"
  },
  {
    title: "Standpipe",
    dial_code: "Standpipe",
    code: "Standpipe"
  },
  {
    title: "Storage Tank",
    dial_code: "Storage Tank",
    code: "Storage_tank"
  },
  {
    title: "Terminal Discharge",
    dial_code: "Terminal Discharge",
    code: "Terminal_discharge"
  },
  {
    title: "Tower",
    dial_code: "Tower",
    code: "Tower"
  },
  {
    title: "Treatment Outfall",
    dial_code: "Treatment Outfall",
    code: "Treatment_outfall"
  },
  {
    title: "Treatment Plant",
    dial_code: "Treatment Plant",
    code: "Treatment_plant"
  },
  {
    title: "Treatment Valve",
    dial_code: "Treatment Valve",
    code: "Treatment_valve"
  },
  {
    title: "Vertical Pipe",
    dial_code: "Vertical Pipe",
    code: "Vertical_pipe"
  },
  {
    title: "Well",
    dial_code: "Well",
    code: "well"
  },
  {
    title: "Wet Basin",
    dial_code: "Wet Basin",
    code: "Wet_basin"
  },
  {
    title: "Yard Hydrant",
    dial_code: "Yard Hydrant",
    code: "Yard_hydrant"
  }
];
